module.exports = __webpack_public_path__ + "img/s1_t1_03.c2af6c43.jpeg";